<template>
  <div id="app">
    <AppHeader class="header"></AppHeader>
    <el-main id="main" style="margin-top: 70px">
      <router-view></router-view>
    </el-main>
  </div>
</template>

<script>
import AppHeader from './components/headers/AppHeader.vue';

export default {
  name: 'app',
  components: {
    AppHeader,
  },
  data() {
    return {
      role: null,
    };
  },
};
</script>

<style lang="scss">
@import url('https://fonts.googleapis.com/css?family=Sarabun&display=swap');
@import "./assets/variables";

body {
  font-family: 'Sarabun', Helvetica, Arial, sans-serif;
  margin: 0;
}

#app {
  font-family: 'Sarabun', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;

  .header {
    box-shadow: 0 4px 8px rgba(87, 87, 87, 0.16);
    background-color: white;
    z-index: 2;
    position: fixed;
    left: 0;
    top: 0;
    width: 100vw;
  }

  #main {
    padding: 20px 56px;
  }
}
</style>
